import styles from '@styles/styles';
import CompactContentContainerStyles from './types';

const compactContentContainerStyles: CompactContentContainerStyles = styles.alignItemsBaseline;

export {
    // eslint-disable-next-line import/prefer-default-export
    compactContentContainerStyles,
};
